if (window.location.pathname.includes('contact')) {

    mapboxgl.accessToken = 'pk.eyJ1IjoiZmxvdmVydCIsImEiOiJjbDRnNDg4amEwMDZhM2JuNnR5c29oN2ZkIn0.Q4MkJaARHfAXen6C4wvg-w';
    // Cf [PROJET JS] mapbox airbnb like - Thomas Mouchelet

    // Url de la page
    const currentUrl = window.location.href;

    // Base Url
    let baseOfUrl = currentUrl.split('/contact/')[0];

    // On intialise la map
    const map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/light-v10',
        center: [2.46544, 46.88888],
        zoom: 2,
    });

    let locationMap = document.querySelector('.accordion');
    let i = 0;

    // On récupère le fichier généré à partir de la pagination en cours
    fetch(baseOfUrl + '/wp-content/uploads/data.json')
    .then(
        resp => {
        return resp.json();
        }
    )
    .then(function(data) {
        
        let items = data.data;

        return items.map((item)=>{
            console.log(item)
            let lng = item.longitude;
            let lat = item.latitude;

            new mapboxgl.Marker({
              color: "rgba(0, 0, 0, .75)"
            })
              .setLngLat([lng, lat])
              .setPopup(
                new mapboxgl.Popup({ offset: 25 })
                  // add popups
                  .setHTML(
                    `
                        <div style="width: 320px">
                            <h5>${item.name}</h5>
                            <p>
                                <!-- <i class="bi bi-geo-alt-fill"></i> -->
                                ${item.adress ? `${item.adress} <br>` : ""}   
                                ${item.comp ? `${item.comp} <br>` : ""}  
                                ${item.zc ? `${item.zc} <br>` : ""} ${item.city ? `${item.city}` : ""}
                                ${item.country ? `${item.country}` : ""}
                            </p>
                            <div class="d-flex justify-content-between pt-2">
                                <p>
                                    ${item.phone ? `${item.phone}<br>` : ""}
                                    ${item.email ? `${item.email}` : ""}
                                </p>
                            </div>
                        </div>
                        `
                  )
              )
              .addTo(map)
            
            // console.log(i);
            let divEl = document.createElement('div');
            divEl.className = 'wpo-location';
            divEl.innerHTML = `
        
                <h4 class="accordion-header" id="${item.id}">
                    <button 
                        class="accordion-button text-upper${i === 0 ? "" : " collapsed"}" 
                        type="button" 
                        data-bs-toggle="collapse" 
                        data-bs-target="#collapse${item.id}" 
                        aria-expanded="${i === 0 ? "true" : "false"}" 
                        aria-controls="${item.id}">
                        ${item.title}
                    </button>
                </h4>
                <div 
                    id="collapse${item.id}" 
                    class="accordion-collapse collapse ${i === 0 ? "show" : ""}" 
                    aria-labelledby="heading${item.id}" 
                    data-bs-parent="#accordionLocation"
                >
                    <div class="accordion-body">
                        <h5 class="small">${item.name}</h5>
                        <p class="small">
                            <!-- <i class="bi bi-geo-alt-fill"></i> -->
                            ${item.adress ? `${item.adress}<br>` : ""} 
                            ${item.comp ? `${item.comp}<br>` : ""}  
                            ${item.zc ? `${item.zc} ` : ""}
                            ${item.city ? `${item.city}<br>` : ""} 
                            ${item.country ? `${item.country}<br>` : ""}

                            ${item.phone ? `${item.phone}&nbsp` : ""}
                            ${item.email ? `${item.email}` : ""}
                        </div>
                    </div>
                </div>
            </div>
            `
            i++;

            console.log(item.name, item.adress, item.comp, item.zc, item.country);
            // console.log(i);
            divEl.addEventListener('mouseenter', () => {
                let currentMarker = new mapboxgl.Marker({
                    color: 'rgba(229, 0, 122, 1)'
                })
                .setLngLat([lng, lat])
                .addTo(map);

                divEl.addEventListener('mouseleave', () => {
                    currentMarker.remove();
                })
            })


            locationMap.appendChild(divEl);

            
        })
    })
    .catch(function(error) {
        console.log(error);
    });


    // Add zoom and rotation controls to the map.
    map.addControl(new mapboxgl.NavigationControl());

    // disable map zoom when using scroll
    map.scrollZoom.disable();
}



    